'use strict';

const langFiles = {
    'en': '/js/i18n/languages/english.json',
    'fr': '/js/i18n/languages/french.json',
    'de': '/js/i18n/languages/german.json',
    'it': '/js/i18n/languages/italian.json',
    'es': '/js/i18n/languages/spanish.json',
};

export function init(options) {
    if (!options) { options = {}; }

    var checkTranslation = $.i18n.messageStore.messages.en.HORSE_NAME_REQUIRED;

    if (checkTranslation === 'Horse Name is required') {
        // Assumes language file has already been loaded if this key exists
        if (options.lang !== null) {
            $.i18n().locale = options.lang;
        } else {
            $.i18n();
        }

        if (options.onLoad !== null) {
            options.onLoad();
        }
    } else {
        $.i18n()
            .load(langFiles)
            .done(() => {
                // only process on load event after language files have been loaded

                if (options.lang !== null) {
                    $.i18n().locale = options.lang;
                } else {
                    $.i18n();
                }

                if (options.onLoad !== null) {
                    options.onLoad();
                }
            });
    }

}

export function changeLanguage(lang) {

    $.ajax({
        type: 'GET',
        url: '/index.cfm?lang=' + lang,
        cache: false,
        success: function () {
            console.log('Switching Language to ', lang);
            location.reload();
        },
        error: function () {
            console.log('Switch Language failed to', lang);
        },
    });

}
